(function () {
  'use strict';

  var categoryBtns   = document.querySelectorAll('.ingredients-filters__tag');
  var categorySelect = document.querySelector('.ingredients-filters__select');
  var letterBtns     = document.querySelectorAll('.ingredients-alphabet__letter');
  var cards          = document.querySelectorAll('.ingredient-card-wrap');
  var grid           = document.querySelector('.ingredients-grid');
  var countEl        = document.querySelector('.ingredients-count');
  var noResults      = document.querySelector('.ingredients-no-results');
  var filterBar      = document.querySelector('.ingredients-filters');

  var activeCategory = 'all';
  var activeLetter   = 'all';

  /* ===== Build alphabet availability map ===== */
  function getAvailableLetters() {
    var letters = {};
    cards.forEach(function (wrap) {
      var name = (wrap.dataset.name || '').trim();
      if (name.length > 0) {
        var first = name.charAt(0).toUpperCase();
        letters[first] = true;
      }
    });
    return letters;
  }

  function initAlphabet() {
    var available = getAvailableLetters();
    letterBtns.forEach(function (btn) {
      var letter = btn.dataset.letter;
      if (letter !== 'all' && !available[letter]) {
        btn.classList.add('ingredients-alphabet__letter--disabled');
      }
    });
  }

  /* ===== Intersection Observer for stagger animation ===== */
  function initCardAnimations() {
    if (window.matchMedia('(max-width: 990px)').matches) return;
    if (document.body.classList.contains('animate--none')) return;

    var animateCards = document.querySelectorAll('.ingredient-card.animate');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var card = entry.target;
            var siblings = Array.from(grid.querySelectorAll('.ingredient-card.animate:not(.animated)'));
            var i = siblings.indexOf(card);
            var delay = Math.min(i, 8) * 80;
            setTimeout(function () {
              card.classList.add('animated');
            }, delay);
            observer.unobserve(card);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    animateCards.forEach(function (card) {
      observer.observe(card);
    });
  }

  /* ===== Sticky filter shadow ===== */
  function initStickyFilter() {
    if (!filterBar) return;
    var sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    sentinel.style.width = '100%';
    sentinel.style.position = 'absolute';
    sentinel.style.top = '0';
    sentinel.style.left = '0';
    sentinel.style.pointerEvents = 'none';
    filterBar.parentNode.insertBefore(sentinel, filterBar);

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          filterBar.classList.toggle('ingredients-filters--stuck', !e.isIntersecting);
        });
      },
      { threshold: [1] }
    );
    obs.observe(sentinel);
  }

  /* ===== Track filter-bar height so the mobile row can pin below it ===== */
  function initFilterHeightVar() {
    if (!filterBar) return;
    var setVar = function () {
      var h = filterBar.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--ingredients-filter-height', h + 'px');
    };
    setVar();
    window.addEventListener('resize', setVar);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(setVar).observe(filterBar);
    }
  }

  /* ===== Horizontal scroll arrows (mobile) ===== */
  function initGridArrows() {
    var wrap = document.querySelector('.ingredients-grid-wrap');
    if (!wrap || !grid) return;
    var prevBtn = wrap.querySelector('[data-grid-prev]');
    var nextBtn = wrap.querySelector('[data-grid-next]');
    if (!prevBtn || !nextBtn) return;

    function getStep() {
      var card = grid.querySelector('.ingredient-card-wrap:not([style*="display: none"])');
      if (!card) return grid.clientWidth;
      var styles = window.getComputedStyle(grid);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrowStates() {
      var max = grid.scrollWidth - grid.clientWidth - 2;
      var atStart = grid.scrollLeft <= 2;
      var atEnd = grid.scrollLeft >= max;
      prevBtn.toggleAttribute('disabled', atStart);
      nextBtn.toggleAttribute('disabled', atEnd);
    }

    prevBtn.addEventListener('click', function () {
      grid.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      grid.scrollBy({ left: getStep(), behavior: 'smooth' });
    });
    grid.addEventListener('scroll', updateArrowStates, { passive: true });
    window.addEventListener('resize', updateArrowStates);
    gridArrowsUpdate = updateArrowStates;
    updateArrowStates();
  }

  /* ===== Filtering ===== */
  function filterCards() {
    var visible = 0;

    cards.forEach(function (wrap) {
      var name     = (wrap.dataset.name || '');
      var category = (wrap.dataset.category || '');

      var matchesCategory = activeCategory === 'all' || category === activeCategory;
      var matchesLetter   = activeLetter === 'all' || name.charAt(0).toUpperCase() === activeLetter;

      if (matchesCategory && matchesLetter) {
        wrap.style.display = '';
        visible++;
      } else {
        wrap.style.display = 'none';
      }
    });

    if (countEl) {
      countEl.textContent = visible + ' ingredient' + (visible !== 1 ? 's' : '');
    }
    if (noResults) {
      noResults.style.display = visible === 0 ? '' : 'none';
    }
    if (grid) {
      grid.style.display = visible === 0 ? 'none' : '';
      grid.scrollLeft = 0;
      if (typeof gridArrowsUpdate === 'function') gridArrowsUpdate();
    }
  }

  var gridArrowsUpdate = null;

  function syncCategoryUI() {
    categoryBtns.forEach(function (b) {
      b.classList.toggle('ingredients-filters__tag--active', (b.dataset.category || 'all') === activeCategory);
    });
    if (categorySelect && categorySelect.value !== activeCategory) {
      categorySelect.value = activeCategory;
    }
  }

  function handleCategoryClick(e) {
    var btn = e.currentTarget;
    activeCategory = btn.dataset.category || 'all';
    syncCategoryUI();
    filterCards();
  }

  function handleCategorySelectChange(e) {
    activeCategory = e.currentTarget.value || 'all';
    syncCategoryUI();
    filterCards();
  }

  function handleLetterClick(e) {
    var btn = e.currentTarget;
    if (btn.classList.contains('ingredients-alphabet__letter--disabled')) return;

    activeLetter = btn.dataset.letter || 'all';

    letterBtns.forEach(function (b) {
      b.classList.toggle('ingredients-alphabet__letter--active', b === btn);
    });

    filterCards();
  }

  /* ===== Flip cards ===== */
  function initFlipCards() {
    cards.forEach(function (wrap) {
      var flipBtn = wrap.querySelector('.ingredient-card__flip-btn');
      var closeBtn = wrap.querySelector('.ingredient-card-back__close');

      if (flipBtn) {
        flipBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          wrap.classList.add('ingredient-card-wrap--flipped');
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          wrap.classList.remove('ingredient-card-wrap--flipped');
        });
      }
    });
  }

  /* ===== Event listeners ===== */
  categoryBtns.forEach(function (btn) {
    btn.addEventListener('click', handleCategoryClick);
  });

  if (categorySelect) {
    categorySelect.addEventListener('change', handleCategorySelectChange);
  }

  letterBtns.forEach(function (btn) {
    btn.addEventListener('click', handleLetterClick);
  });

  /* ===== Init ===== */
  initAlphabet();
  initCardAnimations();
  initStickyFilter();
  initFilterHeightVar();
  initGridArrows();
  initFlipCards();
  filterCards();
})();
